import axios from "axios";
import Config from "../utils/Config";

const BASE_URL = `${Config.API_BASE_URL}/admin`;

class ProvidersService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      },
    };
  }

  async getProviders() {
    try {
      const response = await axios.get(
        `${BASE_URL}/get/providers`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data?.reason || "Providers fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "An error occurred while getting providers",
      };
    }
  }

  async activateProvider(provider_slug) {
    try {
      const response = await axios.post(
        `${BASE_URL}/activate/provider/${provider_slug}`,
        {},
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data?.reason || "Provider activated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "An error occurred while activating provider",
      };
    }
  }


  async deactivateProvider(provider_slug) {
    try {
      const response = await axios.post(
        `${BASE_URL}/deactivate/provider/${provider_slug}`,
        {},
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data?.reason || "Provider deactivated successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "An error occurred while deactivating provider",
      };
    }
  }

  async updateProviderStatus(provider_slug, action) {
    if (action === 'activate') {
      return await this.activateProvider(provider_slug);
    } else if (action === 'deactivate') {
      return await this.deactivateProvider(provider_slug);
    } else {
      return {
        status: false,
        data: null,
        message: "Invalid action. Must be 'activate' or 'deactivate'",
      };
    }
  }
}

const providersService = new ProvidersService();
export default providersService;